import React from 'react';

function InningOutsPicker({ label, minInning = 1, minOuts = 0, inning, outs, onInningChange, onOutsChange }) {
  const isMinInning = inning === minInning;
  return (
    <div className="fld-iop-section">
      <div className="fld-iop-label">{label}</div>
      <div className="fld-iop-row">
        <div className="fld-iop-group">
          <div className="fld-iop-sublabel">Inning</div>
          <div className="fld-iop-chips">
            {[1,2,3,4,5,6,7,8,9].filter(i => i >= minInning).map(i => (
              <button
                key={i}
                type="button"
                className={`fld-iop-chip ${inning === i ? 'active' : ''}`}
                onClick={() => {
                  onInningChange(i);
                  if (i === minInning && outs < minOuts) onOutsChange(minOuts);
                }}
              >
                {i}
              </button>
            ))}
          </div>
        </div>
        <div className="fld-iop-group">
          <div className="fld-iop-sublabel">Outs</div>
          <div className="fld-iop-chips">
            {[0,1,2].map(o => {
              const disabled = isMinInning && o < minOuts;
              return (
                <button
                  key={o}
                  type="button"
                  disabled={disabled}
                  className={`fld-iop-chip ${outs === o ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                  onClick={() => !disabled && onOutsChange(o)}
                >
                  {o}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InningOutsPicker;
